// index.js or main file
import React, { useState, useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Login from './pages/login/login';
import Game from './pages/game/game';
import Thankyou from './pages/thankyou/thankyou';
import Leaderboard from './pages/leaderboard/Leaderboard';
import Admin from './admin/admin';
import DDDUI from './pages/dddUI/ddd';

function usePageBackground() {
  const location = useLocation();

  useEffect(() => {
    const body = document.body;

    body.classList.remove('common-bg', 'common-bg1');

    switch (location.pathname) {
      case '/':
      case '/login':
        body.classList.add('common-bg');
        body.classList.add('common-bg1');

        break;
      case '/game':
        body.classList.remove('rules-bg');
        body.classList.add('common-bg');
        break;
      case '/thankyou':
        body.classList.add('common-bg');
                body.classList.add('common-bg1');
        break;
      case '/leaderboard':
        body.classList.add('common-bg');
        body.classList.add('common-bg1');
        break;
   
        default:
        break;
    }
  }, [location]); 
}


function App() {
  usePageBackground();
  const navigate = useNavigate();
  const location = useLocation();
   
     // Get initial image from sessionStorage or env variable
     const getInitialImage = () => {
       return sessionStorage.getItem("orgData") || process.env.REACT_APP_EM_LOGO;
     };

     const isFromMobileApp = useMemo(() => {
       const inUrl =
         String(new URLSearchParams(location.search).get("fromMobileApp") || "").toLowerCase() ===
         "true";
       if (inUrl) return true;
       try {
         if (sessionStorage.getItem("fromMobileApp") === "true") return true;
       } catch {
         /* ignore */
       }
       try {
         const persisted = JSON.parse(sessionStorage.getItem("userData") || "{}");
         return String(persisted?.fromMobileApp || "").toLowerCase() === "true";
       } catch {
         return false;
       }
     }, [location.search, location.pathname]);
   
     // State for header config
     const [headerConfig, setHeaderConfig] = useState({
       imageUrl: getInitialImage(),
       backButtonRedirect: "/", // Default back button
     });
   
     // Update both image and back button together (ONLY from Login)
     const updateHeader = ({ imageUrl, backButtonRedirect }) => {
       setHeaderConfig((prev) => ({
         imageUrl: imageUrl || prev.imageUrl, // Only update if provided
         backButtonRedirect: backButtonRedirect || prev.backButtonRedirect, // Only update if provided
       }));
   
       // Store image in sessionStorage if provided
       if (imageUrl) sessionStorage.setItem("orgData", imageUrl);
     };
   
   
     const handleBack = () => {
       if (isFromMobileApp) {
         window.GameStatus?.postMessage?.("navigate_back");
         return;
       }
       const { backButtonRedirect } = headerConfig;
   
       if (backButtonRedirect.length > 20) {
         // Open in new tab (External Link)
         window.location.href = backButtonRedirect;
       } else {
         // Internal Navigation
         navigate(backButtonRedirect);
       }
     };

     // Note: we intentionally do NOT globally trap browser-back here.
     // Some mobile webviews emit popstate unexpectedly during boot/login.
     // We rely on the header/logo controls (and page-level guards where needed).
   
  

  // the admin has its own header and layout, so it renders outside the game chrome
  if (location.pathname === '/admin' || location.pathname.startsWith('/admin/')) {
    return <Admin />;
  }

  return (
<DDDUI imageUrl={headerConfig.imageUrl} onBack={handleBack} isFromMobileApp={isFromMobileApp}>
      <Routes>
        <Route path="/" element={<Login updateHeader={updateHeader}/>} />
        <Route path="/game" element={<Game updateHeader={updateHeader}/>} />
        <Route path="/login" element={<Login updateHeader={updateHeader} />} />
        {/* legacy route: keep but redirect straight to game */}
        <Route path="/intro" element={<Game updateHeader={updateHeader}/>} />
        <Route path="/thankyou" element={<Thankyou updateHeader={updateHeader}/>} />
        <Route path="/leaderboard" element={<Leaderboard updateHeader={updateHeader}/>} />
      </Routes>
      </DDDUI>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Performance reporting
reportWebVitals();
